import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=3831113b&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"
import style0 from "./Demo.vue?vue&type=style&index=0&id=3831113b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3831113b",
  null
  
)

export default component.exports